import { createSlice, createAction } from '@reduxjs/toolkit';
import { HiringHeroConfigResource } from 'util/resources/HiringHeroConfig';

export const hiringHeroConfigsLoadSuccesss =
  createAction<HiringHeroConfigResource[]>('hiringHeroConfigs/save');

const slice = createSlice({
  name: 'hiringHeroConfigs',
  initialState: {
    items: [] as HiringHeroConfigResource[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(hiringHeroConfigsLoadSuccesss, (state, action) => {
      state.items = action.payload;
    });
  },
});

export default slice;
